import React from "react";
import ReactModal from "react-modal";
import "../custom-dashboard-modal/custom-dashboard-modal.scss";
import { Form } from "react-bootstrap";
import { saveDashboardState } from "../../../api/";

class CustomDashModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            metrics: [
                {
                    name: "Analytics overview",
                    id: 1,
                },
                {
                    name: "Daily goal",
                    id: 2,
                },
                {
                    name: "Application processing metrics",
                    id: 3,
                },
                {
                    name: "Applications processing",
                    id: 4,
                },
            ],
            dashboardWidgets: {
                analyticsOverview: false,
                dailyGoal: false,
                appsMetrics: false,
                appsProcessing: false,
            },
        };
    }

    componentDidMount = () => {
        this.setState({
            dashboardWidgets: this.props.dashboardWidgets,
        });
    };

    handleChange = (id, e) => {
        e.persist();
        if (e.target.checked) {
            switch (id) {
                case 1:
                    this.setState((prev) => ({
                        dashboardWidgets: {
                            ...prev.dashboardWidgets,
                            analyticsOverview: true,
                        },
                    }));
                    break;
                case 2:
                    this.setState((prev) => ({
                        dashboardWidgets: {
                            ...prev.dashboardWidgets,
                            dailyGoal: true,
                        },
                    }));
                    break;
                case 3:
                    this.setState((prev) => ({
                        dashboardWidgets: {
                            ...prev.dashboardWidgets,
                            appsMetrics: true,
                        },
                    }));
                    break;
                case 4:
                    this.setState((prev) => ({
                        dashboardWidgets: {
                            ...prev.dashboardWidgets,
                            appsProcessing: true,
                        },
                    }));
                    break;
            }
        } else {
            switch (id) {
                case 1:
                    this.setState((prev) => ({
                        dashboardWidgets: {
                            ...prev.dashboardWidgets,
                            analyticsOverview: false,
                        },
                    }));
                    break;
                case 2:
                    this.setState((prev) => ({
                        dashboardWidgets: {
                            ...prev.dashboardWidgets,
                            dailyGoal: false,
                        },
                    }));
                    break;
                case 3:
                    this.setState((prev) => ({
                        dashboardWidgets: {
                            ...prev.dashboardWidgets,
                            appsMetrics: false,
                        },
                    }));
                    break;
                case 4:
                    this.setState((prev) => ({
                        dashboardWidgets: {
                            ...prev.dashboardWidgets,
                            appsProcessing: false,
                        },
                    }));
                    break;
            }
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        saveDashboardState(this.state.dashboardWidgets)
            .then((res) => {
                this.props.updateWidgets(this.state.dashboardWidgets);
                this.props.closeModal();
            })
            .catch((err) => {
                this.props.updateWidgets(this.state.dashboardWidgets);
                this.props.closeModal();
            });
    };

    isChecked = (id) => {
        let checked = true;
        switch (id) {
            case 1:
                checked = this.state.dashboardWidgets.analyticsOverview;
                break;
            case 2:
                checked = this.state.dashboardWidgets.dailyGoal;
                break;
            case 3:
                checked = this.state.dashboardWidgets.appsMetrics;
                break;
            case 4:
                checked = this.state.dashboardWidgets.appsProcessing;
                break;
        }
        return checked;
    };

    render() {
        return (
            <ReactModal isOpen={this.props.show} className="custom-dash-modal">
                <div className="modal-header">
                    <h4 className="text-left">Customise Dashboard</h4>
                </div>
                <div className="modal-cancel" onClick={this.props.closeModal}>
                    <img src="/images/cancel.svg" />
                </div>
                <div className="modal-body">
                    <Form
                        id="set-goal-form"
                        onSubmit={(e) => this.handleSubmit(e)}
                        autoComplete="off"
                    >
                        <p>Choose widgets to show</p>

                        {this.state.metrics.map((item, index) => (
                            <Form.Check
                                key={item.id}
                                defaultChecked={this.isChecked(item.id)}
                                type="checkbox"
                                value={item.id}
                                label={item.name}
                                name="label[]"
                                id={item.id}
                                onChange={(e) => this.handleChange(item.id, e)}
                            />
                        ))}
                    </Form>
                </div>
                <div className="modal-footer">
                    <button
                        form="set-goal-form"
                        type="submit"
                        className="btn confirm-button"
                    >
                        {" "}
                        Confirm{" "}
                    </button>
                    <button
                        className="btn cancel-button"
                        onClick={this.props.closeModal}
                    >
                        {" "}
                        Cancel{" "}
                    </button>
                </div>
            </ReactModal>
        );
    }
}

export default CustomDashModal;
